<template>
  <div class="skin" :style="{backgroundImage:`url(${background})`}">
    <div class="btn-group">
      <div class="rules-btn btn" :style="`background-image:url(${rulesBtnBg})`" @click="answerRule"></div>
      <div class="start-btn btn" :style="`background-image:url(${startBtnBg})`" @click="startAnswering" v-if="isStart"></div>
    </div>
    <div class="ranking-btn" @click="lookResultClick"></div>
  </div>
</template>

<script>
import {formDetail, formSetting, cmsLogin} from "../../api/Interface";

export default {
  name: "skin",
  data() {
    return {
      background: "",
      rulesBtnBg: "",
      startBtnBg: "",
      isStart: true
    }
  },
  created() {
    this.getLogin()
    this.getImg()
  },
  mounted() {
    this.$store.commit('isSubmit', false)
  },
  methods: {
    answerRule() {
      this.$router.push('/explain?id=' + this.$route.query.id)
    },
    getLogin() {
      let _this = this
      let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/mediacloudclient/i) == 'mediacloudclient') {
        //在app内打开
        this.getUrlParams()
        formSetting(this.$route.query.id).then(res => {
          if (res.state) {
            this.$store.commit('settingData', res.data);
            //判断是否需要登录
            if (res.data.base.login_limit) {
              //需要登录
              // 在app内打开
              mc.userGetEncryptInfo(function (data) {
                //已登录
                if (data.state == 1) {
                  let params = {
                    userid: data.data.userid,
                    timestamp: data.data.timestamp,
                    nonce: data.data.nonce,
                    sign: data.data.signature,
                    form_id: _this.$route.query.id
                  }
                  cmsLogin(params).then(res => {
                    if (res.state) {
                      _this.$store.commit('isToken', true)
                      sessionStorage.setItem('token', 'Bearer' + res.data.token)
                      _this.getFormDetail()
                    } else {
                      _this.$Message.error(res.error);
                    }
                  }).catch(error => {
                    console.log(error);
                  })

                } else if (data.state == 0) {
                  // 未登录
                  mc.userLogin(function (data) {
                    if (data.state == 1) {
                      mc.userGetEncryptInfo(function (data2) {
                        if (data2.state == 1) {
                          let params = {
                            userid: data2.data.userid,
                            timestamp: data2.data.timestamp,
                            nonce: data2.data.nonce,
                            sign: data2.data.signature,
                            form_id: _this.$route.query.id
                          }
                          cmsLogin(params).then(res => {
                            if (res.state) {
                              _this.$store.commit('isToken', true)
                              sessionStorage.setItem('token', 'Bearer' + res.data.token)
                              _this.getFormDetail()
                            } else {
                              _this.$Message.error(res.error);
                            }
                          }).catch(error => {
                            console.log(error);
                          })
                        }
                      });
                    }
                  });
                }
              });
            } else {
              _this.getFormDetail()
            }
          }
        })
      } else {
        this.getFormDetail()
      }
    },
    //获取详情
    getFormDetail() {
      let data = {
        form_id: this.$route.query.id,
      }
      if (this.$store.state.code !== '') {
        data.code = this.$store.state.code
      }
      formDetail(data).then(res => {
        if (res.state) {
          this.$store.commit('formTitle', res.data.title)
          this.$store.commit('formType', res.data.type)
          this.isStart = true
        } else {
          this.isStart = false
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //立即答题
    startAnswering() {
      /*重置答案*/
      this.$store.commit('user_answers', {})
      if(this.$store.state.formType ===1){
        this.$router.push('/activity?id=' + this.$route.query.id)
      }else{
        this.$router.push('/answer?id=' + this.$route.query.id)
      }
    },
    //获取网址参数
    getUrlParams() {
      var url = window.location.href; //获取当前url
      var cs = url.split('?')[1];//获取?之后的参数字符串
      var cs_arr = cs.split('&');//参数字符串分割为数组
      var cs = {};
      for (var i = 0; i < cs_arr.length; i++) {//遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
      }
      this.$store.commit('formId', cs.id);//这样就拿到了参数中的数据
    },
    getImg(){
      this.background = this.$store.state.settingData.skin.skinIndex.data.background;
      this.rulesBtnBg = this.$store.state.settingData.skin.skinIndex.data.rulesBtnBg;
      this.startBtnBg = this.$store.state.settingData.skin.skinIndex.data.startBtnBg;
    },
    lookResultClick(){
      this.$router.push('/ranking?id='+ this.$route.query.id+"&clearcache")
    }
  }
}
</script>

<style lang="scss" scoped>
.skin {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  position: relative;
  background-size: 100% 100%;
  .ranking-btn{
    position: absolute;
    top:20px;
    right: 20px;
    width: 83px;
    height: 31px;
    background: url('../../assets/images/ranking.png') no-repeat center/100%;
    z-index:9;
  }
  .btn-group {
    width: 100%;
    height: 126px;
    padding: 0 1rem;
    position: absolute;
    bottom: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .btn {
      width: 70%;
      height: 50px;
      border-radius: 25px;
      font-size: 1.25rem;
      color: #fff;
      text-align: center;
      line-height: 3.125rem;
      background-size: 100% 100%;
    }
  }

}
</style>
